import { useEffect } from 'react';
import { useGlobalStore } from '../../application/store/store.tsx';

function KeyboardListener() {
    const handleKeyInput = useGlobalStore((state) => state.handleKeyInput);

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            // Guard against undefined event or key
            if (event && event.key && handleKeyInput) {
                handleKeyInput(event.key);
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyInput]);

    return null;
}

export default KeyboardListener;
